import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { storyKeys } from '@/contexts/stories/queryKeys';

export function registerAIEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  // Voice clone completed — invalidate customVoices cache
  register('voice.clone.completed', {
    getQueryKeys: (p) => [storyKeys.customVoices(p.familyId as string)],
  });

  register('voice.clone.failed', {
    getQueryKeys: () => [],
  });

  // Voice deleted — invalidate customVoices cache so list updates
  register('voice.deleted', {
    getQueryKeys: (p) => [storyKeys.customVoices(p.familyId as string || '')],
  });

  register('voice.preview.completed', {
    getQueryKeys: () => [],
  });

  register('voice.preview.failed', {
    getQueryKeys: () => [],
  });
}
